// extracted by mini-css-extract-plugin
export default {"pagination":"table-pagination_pagination__fjw+N","range":"table-pagination_range__-XrmN","pageNav":"table-pagination_pageNav__W7YpO"};